import { getCurrencyPrefix, getCurrencyDecimalPlaces, internationalNumberFormatter } from './currencyUtils';

export const formatAmountToDecimal = (amount) =>
	Number.parseFloat(amount).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const formatAmount = (amount) => `£${formatAmountToDecimal(amount)}`;

export const formatIFTAmount = (amount, currency) => {
	const decimalLimit = getCurrencyDecimalPlaces(currency);
	const amountInString = internationalNumberFormatter(currency, decimalLimit, amount) || amount;
	const currencyPrefix = getCurrencyPrefix(currency);

	if (currency === '') {
		return `${currencyPrefix} ${amountInString} ${currency}`.trim();
	}
	return `${currencyPrefix} ${amountInString.slice(4, amountInString.length)} ${currency}`.trim();
};
